import renderChart from './renderChartMixin'

export default{
  mixins: [renderChart],
  props: {
    myDataset : {type: Object, required: true},
    options   : {type: Object},
    color     : {type: String, default:'#505050'}
  },
  data(){
    return{
      default:{
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            gridLines: {
              //display: false,
              drawBorder: false,
            },
            categoryPercentage: 0.85,
            barPercentage: 0.85
          }],
          xAxes: [ {
            ticks: {
              beginAtZero: true,
              min: 0,
              stepSize: 15,
              autoSkip: false
            },
            gridLines: {
              display: false,
              drawBorder: false
            },
          }],
        },
        responsive: true,
        maintainAspectRatio: true,
      }
    }
  },
  computed:{
    chartData(){
      return{
        datasets:[{
          data  : this.myDataset.values,
          backgroundColor: this.color
        }],
        labels : this.myDataset.labels
      }
    }
  }
}